import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  trialPaymentDisclaimer: {
    defaultMessage: "*After your trial period, the first month's fee will be prorated then {price}/mo for future billing cycles.",
    description: 'A disclaimer to pop up to the user should they try to enable addons while in a trial phase',
    id: 'zdxSP7',
  },
  addOnPaymentDisclaimer: {
    defaultMessage:
      '*Your first-month fee will be prorated. Starting with your next billing cycle, the full {price}/mo add-on fee will apply.',
    id: 'UAOLUU',
    description: 'Disclaimer that displays when this is NOT A trial Add-On',
  },
  fulfillmentProviderBundleAdditionalCharges: {
    defaultMessage: '*Plus {price} per shipped client order after the first 1k/mo',
    id: 'ipqq74',
    description: 'disclaimer text that displays when this is the ShipStation 3PL Add-On because there are additional charges',
  },
  dropShipAdditionalCharges: {
    defaultMessage: '*Plus $0.03 per each delegated vendor shipment',
    id: 'LnWB8A',
    description: 'disclaimer text that displays when this is the DropShip Add-On because there are additional charges',
  },
});
